import React from "react";
import { MessageCircle, Projector } from "lucide-react";
import { EVENTS, whatsappLink } from "../lib/constants";

export default function Events() {
    return (
        <section id="events" className="relative py-24 md:py-32 bg-coffee-50" data-testid="events-section">
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-14">
                    <div className="lg:col-span-6">
                        <p className="text-xs tracking-[0.3em] uppercase text-forest-700 mb-5">Celebrate at Veeras</p>
                        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light text-coffee-900 leading-tight">
                            Host your moments <span className="italic text-forest-700">amidst the mist.</span>
                        </h2>
                    </div>
                    <p className="lg:col-span-5 lg:col-start-8 text-stone-600 text-base md:text-lg self-end leading-relaxed">
                        The estate, dining hall, poolside and lantern-lit courtyards are
                        available for private parties, birthdays, traditional weddings, family
                        functions — and full-fledged <span className="font-medium text-coffee-800">corporate offsites &amp; meetings</span>,
                        complete with projectors and conference setup.
                    </p>
                </div>

                <div className="grid grid-cols-2 lg:grid-cols-5 gap-4 md:gap-6">
                    {EVENTS.map((e, i) => (
                        <div
                            key={e.title}
                            className="group relative h-64 md:h-80 overflow-hidden rounded-2xl"
                            data-testid={`event-card-${i}`}
                        >
                            <img src={e.image} alt={e.title} className="absolute inset-0 h-full w-full object-cover group-hover:scale-110 transition-transform duration-[1200ms]" />
                            <div className="absolute inset-0 bg-gradient-to-t from-coffee-900 via-coffee-900/20 to-transparent" />
                            <div className="absolute bottom-5 left-5 right-5 flex items-center justify-between">
                                <h3 className="font-serif text-cream text-xl md:text-2xl">{e.title}</h3>
                                <span className="text-cream/80 text-xs tracking-widest">0{i + 1}</span>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Corporate meeting note */}
                <div className="mt-10 p-6 md:p-8 bg-white border border-sand rounded-2xl flex flex-col md:flex-row items-start md:items-center gap-5" data-testid="corporate-note">
                    <span className="inline-flex h-12 w-12 rounded-full bg-forest-700/10 text-forest-700 items-center justify-center shrink-0">
                        <Projector className="h-5 w-5" />
                    </span>
                    <div className="flex-1">
                        <h4 className="font-serif text-xl md:text-2xl text-coffee-900">Corporate offsites &amp; meetings</h4>
                        <p className="text-stone-600 text-sm md:text-base mt-1">
                            We rent out the property for full-day corporate workshops and offsite
                            meetings — equipped with projectors, screens, ample seating and a
                            quiet, distraction-free setting. Custom packages on request.
                        </p>
                    </div>
                </div>

                <div className="mt-12 flex justify-center">
                    <a
                        href={whatsappLink("Hi, I'd like to enquire about hosting an event at Veeras Resorts.")}
                        target="_blank"
                        rel="noreferrer"
                        className="inline-flex items-center gap-3 bg-coffee-900 text-cream px-7 py-4 rounded-full font-medium hover:bg-coffee-800 transition-colors"
                        data-testid="events-enquire-btn"
                    >
                        <MessageCircle className="h-4 w-4" /> Plan an event with us
                    </a>
                </div>
            </div>
        </section>
    );
}
